export default __webpack_public_path__ + "static/media/2.a6c9ee57.png";